import { useState, useEffect } from 'react';
import { getBackgroundByTime } from '../utils/background';

interface UseBackgroundOptions {
  isCameraActive?: boolean;
}

/**
 * 背景画像を管理するカスタムフック
 */
export function useBackground(options: UseBackgroundOptions = {}) {
  const { isCameraActive = false } = options;
  const [backgroundImage, setBackgroundImage] = useState<string>('');
  const [originalBackground, setOriginalBackground] = useState<string>('');

  // 初回マウント時と時間帯が変わったときに背景を更新
  useEffect(() => {
    const updateBackground = () => {
      if (isCameraActive) {
        // カメラ使用中は背景を非表示
        if (backgroundImage && backgroundImage !== 'none') {
          setOriginalBackground(backgroundImage);
        }
        setBackgroundImage('none');
      } else {
        // 通常時は時間帯に応じた背景
        const bgPath = getBackgroundByTime();
        setBackgroundImage(`url(${bgPath})`);
      }
    };

    // 初回設定
    updateBackground();

    // 1時間ごとに背景を更新（時間帯の変化に対応）
    const interval = setInterval(updateBackground, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, [isCameraActive]);

  // カメラ終了時に元の背景を復元
  useEffect(() => {
    if (!isCameraActive && originalBackground) {
      setBackgroundImage(originalBackground);
      setOriginalBackground('');
    }
  }, [isCameraActive, originalBackground]);

  return {
    backgroundImage,
    refreshBackground: () => {
      if (!isCameraActive) {
        const bgPath = getBackgroundByTime();
        setBackgroundImage(`url(${bgPath})`);
      }
    }
  };
}